import { Facebook } from 'lucide-react';
import { ContactCTA } from '../components/ContactCTA';
import { OILS_PAGE, SITE } from '../data/content';
import { Helmet } from 'react-helmet-async';

export default function OilsPage() {
  return (
    <div data-testid="oils-page" className="pt-20">
    <Helmet>
        <title>Illóolajok a terápiában | Mosolytorna</title>
        <meta name="description" content="Kiegészítő aromaterápia és doTERRA illóolajok alkalmazása a logopédiai fejlesztés támogatására, a figyelem és a nyugalom megteremtéséért." />
      </Helmet>
      <section className="py-12 md:py-20 bg-white" aria-labelledby="oils-heading">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h1
                id="oils-heading"
                className="text-3xl sm:text-4xl md:text-5xl font-light mb-5 md:mb-6 text-gray-800"
                style={{ fontFamily: 'Outfit, sans-serif' }}
                data-testid="oils-title"
              >
                Esszenciális olajok
              </h1>
              <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
                {OILS_PAGE.intro}
              </p>
            </div>

            {/* How I use them */}
            <section className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-16" aria-labelledby="oils-usage-heading">
              <div className="order-2 md:order-1">
                <h2
                  id="oils-usage-heading"
                  className="text-3xl font-light text-gray-800 mb-6"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  Hogyan használom a terápiában?
                </h2>

                <ul className="space-y-6 list-none p-0 m-0">
                  {OILS_PAGE.usageItems.map((item, i) => {
                    const ItemIcon = item.Icon;
                    return (
                      <li key={i} className="flex items-start gap-4">
                        <div
                          className={`w-12 h-12 bg-gradient-to-br ${item.gradient} rounded-xl flex items-center justify-center flex-shrink-0 shadow-md`}
                          aria-hidden="true"
                        >
                          <ItemIcon className="w-6 h-6 text-white" />
                        </div>
                        <div>
                          <h3 className="font-semibold text-gray-800 mb-2">{item.title}</h3>
                          <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>

              <div className="order-1 md:order-2">
                <img
                  src="https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
                  alt="Esszenciális illóolajok üvegcsék"
                  className="rounded-3xl w-full object-cover shadow-2xl max-h-96"
                  onError={(e) => {
                    e.target.src = '/child-therapy.png';
                    e.target.alt = 'Terápiás munkám illusztrációja';
                  }}
                />
              </div>
            </section>

            {/* Community Banner */}
            <section
              data-testid="oils-community-banner"
              className="bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 rounded-3xl p-8 md:p-12 text-white shadow-xl"
              aria-labelledby="community-heading"
            >
              <div className="max-w-3xl mx-auto text-center">
                <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6 backdrop-blur-sm" aria-hidden="true">
                  <Facebook className="w-8 h-8 text-white" />
                </div>

                <h2
                  id="community-heading"
                  className="text-3xl md:text-4xl font-light mb-4"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {OILS_PAGE.community.title}
                </h2>

                <p className="text-xl mb-4 opacity-90">{OILS_PAGE.community.subtitle}</p>

                <p
                  className="text-base mb-8 opacity-90 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: OILS_PAGE.community.desc }}
                />

                <a
                  href={SITE.facebookGroupUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="facebook-group-link"
                  className="inline-flex items-center gap-2 px-8 py-4 bg-white text-pink-600 rounded-full font-medium hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 no-underline"
                >
                  <Facebook className="w-5 h-5" aria-hidden="true" />
                  {OILS_PAGE.community.ctaLabel}
                  <span className="sr-only"> (új ablakban nyílik meg)</span>
                </a>

                <p className="mt-6 text-sm opacity-75">{OILS_PAGE.community.note}</p>
              </div>
            </section>
          </div>
        </div>

        <ContactCTA />
      </section>
    </div>
  );
}
